import { getCampaigns } from '../../api';
import { useProcessedList } from '../../hooks';
import type { GetCampaignsFilters, CampaignType } from '../../api';

export const useCampaigns = () => {
  return useProcessedList<CampaignType, GetCampaignsFilters>(
    async params => {
      const result = await getCampaigns(
        params?.filters || {},
        params.pagination
      );

      return { content: result };
    },
    {
      initialFilters: { status: '' },
      initialSort: { name: 'name', direction: 'asc' },
      searchKeys: ['name', 'description'],
      searchFilterKey: 'search',
      withLocalSort: true,
      withQueryParams: true,
    }
  );
};

export type ItemType = CampaignType;
